import React, { useEffect, useState } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import ModalSave from "../../common/ModelSave";
import { CancelButton, SaveButton } from "../../common/Button";
import { Row, Col, Form, Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { putData } from "../../../utils/api";

const ProductDiscount = (props) => {
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data) => {
    try {
      const finalData = new FormData();

      finalData.append("prod_discount", data?.prod_discount);

      const response = await putData(
        `/admin/products/discount/${props?.show}`,
        finalData,
      );

      if (response?.success) {
        setShowModal({
          code: response.code,
          message: response?.data,
        });
      } else {
        setShowModal({
          code: response?.code,
          message: response?.errors,
        });
      }

      setTimeout(() => {
        setShowModal({
          code: 0,
          message: "",
        });

        props.handleClose();
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (props?.show && props?.data) {
      reset({
        prod_discount:
          props?.data?.prod_discount !== null &&
          props?.data?.prod_discount !== undefined
            ? String(props?.data?.prod_discount)
            : "",
      });
    } else {
      reset({
        prod_discount: "",
      });
    }
  }, [props?.show, props?.data, reset]);

  return (
    <>
      <Modal
        show={props?.show ? true : false}
        onHide={props.handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            {props?.data?.prod_discount !== null &&
            props?.data?.prod_discount !== undefined
              ? "Edit Product Discount"
              : "Enter Product Discount"}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form onSubmit={handleSubmit(onSubmit)} role="form">
            <Row>
              <Col md={6}>
                <Form.Label>Product Discount (%)</Form.Label>

                <Form.Control
                  type="text"
                  inputMode="decimal"
                  placeholder="Enter Product Discount"
                  {...register("prod_discount", {
                    required: "Product Discount is required",

                    validate: (value) => {
                      if (!/^\d+(\.\d{1,2})?$/.test(value)) {
                        return "Enter a valid discount";
                      }

                      const num = Number(value);

                      if (num < 0 || num > 100) {
                        return "Product Discount must be between 0 and 100";
                      }

                      return true;
                    },
                  })}
                  isInvalid={!!errors?.prod_discount}
                  onKeyDown={(e) => {
                    const allowedKeys = [
                      "Backspace",
                      "Delete",
                      "ArrowLeft",
                      "ArrowRight",
                      "ArrowUp",
                      "ArrowDown",
                      "Home",
                      "End",
                      "Tab",
                      "Enter",
                    ];

                    // Allow copy, paste, cut, select all
                    if (
                      allowedKeys.includes(e.key) ||
                      e.ctrlKey ||
                      e.metaKey
                    ) {
                      return;
                    }

                    // Allow numbers
                    if (/^[0-9]$/.test(e.key)) {
                      const value = e.currentTarget.value;
                      const start = e.currentTarget.selectionStart;
                      const end = e.currentTarget.selectionEnd;

                      // Allow typing when text is selected
                      if (start !== end) {
                        return;
                      }

                      // Maximum 2 digits after decimal
                      if (value.includes(".")) {
                        const decimalIndex = value.indexOf(".");

                        if (
                          start > decimalIndex &&
                          value.substring(decimalIndex + 1).length >= 2
                        ) {
                          e.preventDefault();
                        }
                      }

                      return;
                    }

                    // Allow only one decimal point
                    if (
                      e.key === "." &&
                      !e.currentTarget.value.includes(".")
                    ) {
                      return;
                    }

                    // Block all other characters
                    e.preventDefault();
                  }}
                  onPaste={(e) => {
                    const pastedText = e.clipboardData
                      .getData("text")
                      .trim();

                    // Only numbers with maximum 2 decimal places
                    if (!/^\d+(\.\d{1,2})?$/.test(pastedText)) {
                      e.preventDefault();
                      return;
                    }

                    // Maximum 100
                    if (Number(pastedText) > 100) {
                      e.preventDefault();
                    }
                  }}
                  onInput={(e) => {
                    let value = e.target.value;

                    // Remove anything except numbers and dot
                    value = value.replace(/[^\d.]/g, "");

                    // Keep only first decimal point
                    const parts = value.split(".");

                    if (parts.length > 2) {
                      value =
                        parts[0] + "." + parts.slice(1).join("");
                    }

                    // Maximum 2 decimal places
                    if (value.includes(".")) {
                      const [integerPart, decimalPart] =
                        value.split(".");

                      value =
                        integerPart +
                        "." +
                        decimalPart.slice(0, 2);
                    }

                    // Maximum value 100
                    if (Number(value) > 100) {
                      value = "100";
                    }

                    e.target.value = value;
                  }}
                />

                {errors?.prod_discount && (
                  <div className="invalid-feedback">
                    {errors.prod_discount.message}
                  </div>
                )}
              </Col>
            </Row>

            <Row className="mt-5 pb-3">
              <div className="d-flex justify-content-center">
                <Link>
                  <CancelButton
                    name={"Cancel"}
                    handleClose={props.handleClose}
                  />
                </Link>

                <SaveButton
                  name={"Save"}
                  handleSubmit={handleSubmit(onSubmit)}
                />
              </div>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default ProductDiscount;